import { isEmpty } from "lodash";
import log from "loglevel";

export type LogLevelConfig = {
  logLevel: string;
};

export function initializeLogLevel(config: LogLevelConfig) {
  const normalize = (level: string): keyof typeof log.levels => {
    if (isEmpty(level)) {
      return "WARN";
    }

    if (!Object.hasOwn(log.levels, level)) {
      console.warn(`[initializeLogLevel] Invalid log level specified: '${level}'. Defaulting to WARN.`);
      return "WARN";
    }

    return level as keyof typeof log.levels;
  };

  log.setLevel(log.levels[normalize(config.logLevel)]);
}
